import React, { useEffect } from 'react';
import { useGlobalDialogs } from '../../state/ui/dialog/index.hooks';
import options from './options';

const GlobalDialog = () => {
    const dialogs = useGlobalDialogs();

    useEffect(() => {
        const overlay = document.querySelector('.overlay');
        if (dialogs.length > 0) {
            overlay?.classList.add('overlay__visible');
        } else {
            overlay?.classList.remove('overlay__visible');
        }
    }, [dialogs.length]);
    return (
        <>
            {dialogs.map((dialog, index) => (
                <div key={index} style={{ zIndex: 1000 + index }}>
                    {options[dialog.dialogType](dialog.dialogData)}
                </div>
            ))}
        </>
    );
};

export default GlobalDialog;
